<template>
  <div ref="Atmosphere" id="Atmosphere" class="atmosphere_animate_wrap">
    <video
        class="bg_video"
        :style="{width: `${defaultWidth}px`, height: `${defaultHeight}px`}"
        autoplay
        muted
        loop
    >
      <source :src="atmosphereVideoBg" type="video/webm">
    </video>
    <div class="cpu_load_label_wrap">{{nowCpuLoad.type_label}}</div>
    <div class="cpu_load_value_wrap">{{nowCpuLoad.value_label}}</div>
    <div class="cpu_load_unit_wrap">{{nowCpuLoad.Unit}}</div>

    <div class="gpu_load_label_wrap">{{nowGpuLoad.type_label}}</div>
    <div class="gpu_load_value_wrap">{{nowGpuLoad.value_label}}</div>
    <div class="gpu_load_unit_wrap">{{nowGpuLoad.Unit}}</div>

    <div class="date_time_wrap">
      <div class="date_wrap">{{nowDateTimeObj.obj.date}}</div>
      <div class="time_wrap">
        <span class="unit_label">{{nowDateTimeObj.obj.a}}</span>
        <span class="time_label">{{nowDateTimeObj.obj.time}}</span>
      </div>
    </div>

    <div class="temp_wrap">
      <div class="cpu_temp_wrap">
        <span class="title_label">{{nowCpuTemp.type_label}}</span>
        <span class="value_label">{{nowCpuTemp.value_label}}</span>
        <span class="unit_label">{{nowCpuTemp.Unit}}</span>
      </div>
      <div class="gpu_temp_wrap">
        <span class="title_label">{{nowGpuTemp.type_label}}</span>
        <span class="value_label">{{nowGpuTemp.value_label}}</span>
        <span class="unit_label">{{nowGpuTemp.Unit}}</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import atmosphereVideoBg from '@/assets/atmosphere/atmosphere_video_bg.webm'
import defaultValue from "@/utils/defaultValue"
import {onMounted, onUnmounted, reactive, ref, watch} from "vue";
import moment from "moment";
const {defaultWidth, defaultHeight} = defaultValue()
const props = defineProps(['sensorValue'])
const nowCpuTemp = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '°F'
})
const nowGpuTemp = reactive({
  type_label: 'GPU',
  value_label: '--',
  Unit: '°F'
})
const nowCpuLoad = reactive({
  type_label: 'CPU Load',
  value_label: '--',
  Unit: '%'
})

const nowGpuLoad = reactive({
  type_label: 'GPU Load',
  value_label: '--',
  Unit: '%'
})

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
const startTime = () => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('YYYY/MM/DD,HH:mm,a').split(',')
  const timeTextObj = {
    date: nowDate[0],
    time: nowDate[1], // 時間
    a: nowDate[2].toLocaleUpperCase()
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}


watch(
    props.sensorValue,
    (n) => {
      if (n) {
        const {
          CPULoad,
          CPUTemperature,
          GPULoad,
          GPUTemperature
        } = n
        if (CPULoad && Object.keys(CPULoad).length > 0) {
          Object.assign(nowCpuLoad, CPULoad, {
            value_label: parseInt(CPULoad.Value) > 0 ? CPULoad.Value : '--'
          })
        }
        if (CPUTemperature && Object.keys(CPUTemperature).length > 0) {
          Object.assign(nowCpuTemp, CPUTemperature, {
            type_label: `${CPUTemperature.Type}`,
            value_label: parseInt(CPUTemperature.Value) > 0 ? CPUTemperature.Value : '--'
          })
        }
        if (GPULoad && Object.keys(GPULoad).length > 0) {
          Object.assign(nowGpuLoad, GPULoad, {
            value_label: parseInt(GPULoad.Value) > 0 ? GPULoad.Value : '--'
          })
        }
        if (GPUTemperature && Object.keys(GPUTemperature).length > 0) {
          Object.assign(nowGpuTemp, GPUTemperature, {
            type_label: `${GPUTemperature.Type}`,
            value_label: parseInt(GPUTemperature.Value) > 0 ? GPUTemperature.Value : '--'
          })
        }
      }
    },
    {immediate: true}
)

onMounted(() => {
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
})



</script>

<style lang="scss">
@import "src/assets/scss/font-family";

.atmosphere_animate_wrap {
  position: relative;
  .bg_video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .cpu_load_label_wrap {
    position: absolute;
    top: 204px;
    left: 62px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 29px;
    color: #FEC000;
    line-height: 1;
    text-align: center;
    width: 128px;
    text-shadow: 0px 0px 3px #FEC000;
  }
  .cpu_load_value_wrap {
    position: absolute;
    display: inline-block;
    min-width: 148px;
    top: 99px;
    left: 43px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 95px;
    color: #F5F5F5;
    line-height: 1;
    text-align: center;
    text-shadow: 0px 0px 5px #17BEFF;
  }
  .cpu_load_unit_wrap {
    position: absolute;
    display: inline-block;
    top: 176px;
    left: 176px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 27px;
    color: #F5F5F5;
    line-height: 1;
    text-align: center;
  }
  .gpu_load_label_wrap {
    position: absolute;
    top: 294px;
    left: 309px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 29px;
    color: #1A4379;
    line-height: 1;
    text-align: center;
    width: 128px;
    text-shadow: 0px 0px 5px #17BEFF;
  }
  .gpu_load_value_wrap {
    position: absolute;
    display: inline-block;
    min-width: 148px;
    top: 190px;
    left: 292px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 95px;
    color: #F5F5F5;
    line-height: 1;
    text-align: center;
    text-shadow: 0px 0px 5px #17BEFF;
  }
  .gpu_load_unit_wrap {
    position: absolute;
    display: inline-block;
    top: 267px;
    left: 424px;
    font-family: HyperspaceRace_BoldItalic;
    font-size: 27px;
    color: #F5F5F5;
    line-height: 1;
    text-align: center;
  }
  .temp_wrap {
    position: absolute;
    display: inline-block;
    top: 305px;
    left: 31px;
    font-family: HyperspaceRace_BoldItalic;
    width: 180px;
    .cpu_temp_wrap {
      color: #FEC000;
      margin-bottom: 13px;
    }
    .gpu_temp_wrap {
      color: #0BC5C5;
    }
    .cpu_temp_wrap, .gpu_temp_wrap {
      font-size: 33px;
      line-height: 1;
      letter-spacing: 0.13px;
      .title_label {
        display: inline-block;
        width: 62px;
        text-shadow: 0px 0px 5px #000000;
      }
      .value_label {
        display: inline-block;
        width: 64px;
        text-align: center;
        color: #fff;
      }
      .unit_label {
        color: #fff;
      }
    }
  }

  .date_time_wrap {
    position: absolute;
    top: 45px;
    left: 280px;
    font-family: HyperspaceRace_BoldItalic;
    color: #0BC5C5;
    width: 178px;
    .date_wrap {
      font-size: 30px;
      line-height: 1;
      text-align: left;
      margin-bottom: 2px;
      text-shadow: 0px 0px 3px #0BC5C5;
    }
    .time_wrap {
      text-align: left;
      .unit_label {
        font-size: 25px;
        vertical-align: top;
        padding-right: 4px;
        letter-spacing: 0.1px;
        text-shadow: 0px 0px 3px #0BC5C5;
      }
      .time_label {
        display: inline-block;
        min-width: 139px;
        text-align: center;
        font-size: 55px;
        line-height: .8;
        letter-spacing: 0.22px;
        text-shadow: 0px 0px 3px #0BC5C5;
      }
    }
  }
}
</style>
